import { Box } from '@mui/material';

export default function HomeView() {
  return (
    <Box>
      <h4>Welcome to the Compass Ag Solutions Portal!</h4>
    </Box>
  );
}
